export const SERVICE_TYPE_ID = {
  ARG: {
    service: 5,
    diagnosis: 6,
    repairs: 7,
    alignmentAndBalancing: 8,
    bodyworkAndPainting: 10,
    pickupAndDelivery: 12,
    contactless: 13,
    mobileService: 14,
  },
  BRA: {
    revision: 1,
    diagnosis: 2,
    repairs: 3,
    alignmentAndBalancing: 4,
    pickupAndDelivery: 11,
    services: 15,
    iolm: 50,
  },
};